<template>
  <div v-bind="disableButton? null : $attrs">
    <template v-if="isPublic">
      <AppTooltip :disabled="!isClickable" data-locator="rights-tooltip">
        <template #activator="{ props }">
          <app-button :disabled="disableButton"
                      type="counter"
                      variant="neutral"
                      v-bind="props"
                      @click="$emit($event.type, $event)"
                      :size="buttonSize"
                      :class="{ 'app-button--compact': compact }"
                      data-locator="rights-button"
          >
            <app-material-icon name="group" />
          </app-button>
        </template>
        <div>
          {{$t('common.users.RightsDisplayButton.everyone')}}
        </div>
      </AppTooltip>
    </template>
    <template v-else>
      <AppTooltip :disabled="!isClickable" data-locator="rights-tooltip">
        <template #activator="{ props }">
          <app-button :disabled="disableButton"
                      type="counter"
                      variant="neutral"
                      v-bind="props"
                      :size="buttonSize"
                      :class="{ 'app-button--compact': compact }"
                      data-locator="rights-button"
          >
            <app-material-icon name="lock" />
            <span class="text-text-tertiary body-md-bold" data-locator="rights-count"> {{ numberOfGroupsAndMembers }} </span>
          </app-button>
        </template>
        <template v-if="groups.length > 0">
          <div>{{$t('common.users.RightsDisplayButton.sharedWith')}}</div>
            <div v-for="group in groups" :key="`group-${group.id}`" class="d-flex align-center column-gap-2">
              <app-material-icon name="group" color="inherit" />
              <span>{{group.name}}</span>
            </div>
            <div v-for="member in members" :key="`member-${member.id}`" class="d-flex align-center column-gap-2">
              <app-material-icon name="person" color="inherit" />
              <span>{{member.fullName}}</span>
            </div>
        </template>
      </AppTooltip>
    </template>
  </div>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'

export default {
  name: 'RightsDisplayButton',
  components: {
    AppTooltip,
  },
  props: {
    rights: {
      type: Object,
      required: true,
    },
    block: {
      type: Boolean,
    },
    isClickable: {
      type: Boolean,
      default: true,
    },
    disableButton: {
      type: Boolean,
    },
    compact: {
      type: Boolean,
    },
  },
  // We'll handle events on separate nodes. We don't want to handle events through the div wrapper
  inheritAttrs: false,
  computed: {
    // If we're using the signature with read rights, read is always an object
    // Otherwise it'll be undefined
    hasReadRights () {
      return this.rights.read
    },
    isPublic () {
      if (this.hasReadRights) {
        return this.rights.read.isPublic
      } else {
        return this.rights.isPublic
      }
    },
    numberOfGroupsAndMembers () {
      return this.groups.length + this.members.length
    },
    groups () {
      if (this.hasReadRights) {
        if (this.rights.read.groups.length > 0) {
          return this.rights.read.groups
        }
      } else {
        return this.rights.groups
      }
      return []
    },
    members () {
      if (this.hasReadRights) {
        if (this.rights.read.users.length > 0) {
          return this.rights.read.users
        }
      } else {
        return this.rights.users
      }
      return []
    },
    buttonSize () {
      return this.compact ? '' : 'medium'
    },
  },
}
</script>
